import React, { Fragment } from 'react'
import { Card, CardBody, Col, Container, Row, Button,Input } from 'reactstrap';
import { ModalPrecodedText } from '../../components/precodedTexts/ModalPrecodedText';
import { TableStriped } from '../../components/tables/TableStriped';
import { usePrecodedText } from '../../hooks/precodedTexts/usePrecodedText';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';


export const IndexPrecodedTexts = ({ activeTab }) => {
    const {
        precodedTexts, typePrecodedTexts, method,
        id_type_precoded_text, text, handleInputChange, validaciones,
        toggle, modal, loading,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        nextPage, previousPage, goToPage, totalPageCount, currentPage,handleSearchTypePrecod
    } = usePrecodedText({ activeTab });

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const actions = (rowData) => {
    
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button 
                    color="primary" 
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_precoded_text)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                    
                >
                    <i className="fa fa-edit"></i>
                </Button>


                <Button 
                    color="danger" 
                    size="sm"
                    onClick={() => handleDelete(rowData.id_precoded_text)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </Button>
            </div>
        );
    };



    return (
        <Fragment>
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody className="p-1">
                                    <div
                                    className="d-flex align-items-center justify-content-between"
                                    style={{ width: "100%", gap: "1rem", flexWrap: "nowrap" }}
                                    >
                                    <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                                        <div
                                        className="ribbon ribbon-clip ribbon-primary"
                                        style={{
                                            display: "inline-flex",    
                                            alignItems: "center",
                                            marginBottom: "0",            
                                            whiteSpace: "nowrap"           
                                        }}
                                        >
                                        Listado de textos precodificados
                                        </div>

                                        <Button
                                        className="btn btn-pill btn-air-success"
                                        color="secondary"
                                        size="sm"
                                        onClick={handleCreate}
                                        title="Crear nuevo texto precodificado"
                                        style={{marginLeft: "260px"}}
                                        >
                                        <span className="fa fa-plus-circle"></span>
                                        </Button>
                                    </div>

                                    <div style={{ width: "300px", flexShrink: 0 }}>
                                        <Input
                                        placeholder="Búsqueda..."
                                        className="form-control"
                                        onChange={handleSearchTypePrecod}
                                        />
                                    </div>
                                    </div>

                                    <br />
                                <DataTable 
                                    value={precodedTexts} 
                                    paginator
                                    rows={10}
                                    rowsPerPageOptions={[10, 20, 50]} 
                                    className="data-table p-datatable-striped p-datatable-sm"
                                    responsiveLayout="scroll"
                                    emptyMessage={
                                        <div className="text-center">
                                            <img 
                                                src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} 
                                                style={{ width: "25%" }} 
                                                alt="Sin resultados" 
                                            />
                                            <br />
                                            <p className='badge badge-light-primary mt-2' style={{fontSize: "15px"}}>
                                                No hay coincidencias con la búsqueda.
                                            </p>
                                        </div>
                                    }
                                    >

                                    <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                    <Column field="type_name" header="Tipo de texto precodificado"  headerStyle={headerStyle} style={centerStyle} />
                                    <Column field="text" header="Nombre"  headerStyle={headerStyle} style={centerStyle} />

                                    <Column header="Acciones" body={actions}exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                </DataTable>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <ModalPrecodedText
                {...{ modal, toggle, loading, method, id_type_precoded_text, text, typePrecodedTexts, handleInputChange, validaciones, saveCreate, saveUpdate, saveDelete }}
            />
        </Fragment>
    )
}
